<ejs-tab Selecting="Select" id="element" class="mt-2" [animation]="animation" heightAdjustMode="fill" (created)="onTabsCreated($event)" (selecting)="select($event)">
  <e-tabitems>
    <e-tabitem>
      <ng-template #headerText>
        {{'i18n.domain.export-configuration.configurations.forms.general.title' | translate}}
        @if(!configurationFormService.configurationFormGeneral.valid){
          <span class="icon-warning--alt text-warning ms-2"></span>
        }
      </ng-template>
      <ng-template #content>
        <app-configuration-form-general></app-configuration-form-general>
      </ng-template>
    </e-tabitem>
    <e-tabitem>
      <ng-template #headerText>
        {{'i18n.domain.export-configuration.configurations.forms.backlog.title' | translate}}
        @if(!configurationFormService.configurationFormBacklog.valid){
          <span class="icon-warning--alt text-warning ms-2"></span>
        }
      </ng-template>
      <ng-template #content>
        <app-configuration-form-backlog></app-configuration-form-backlog>
      </ng-template>
    </e-tabitem>
    <e-tabitem>
      <ng-template #headerText>
        {{'i18n.domain.export-configuration.configurations.forms.finance.title' | translate}}
        @if(!configurationFormService.configurationFormFinance.valid){
          <span class="icon-warning--alt text-warning ms-2"></span>
        }
      </ng-template>
      <ng-template #content>
        <app-configuration-form-finance></app-configuration-form-finance>
      </ng-template>
    </e-tabitem>
    <e-tabitem>
      <ng-template #headerText>
        {{'i18n.domain.export-configuration.configurations.forms.timeplan.title' | translate}}
        @if(!configurationFormService.configurationFormTimeplan.valid){
          <span class="icon-warning--alt text-warning ms-2"></span>
        }
      </ng-template>
      <ng-template #content>
        <app-configuration-form-timeplan></app-configuration-form-timeplan>
      </ng-template>
    </e-tabitem>
    <e-tabitem>
      <ng-template #headerText>
        {{'i18n.shared.fields.email' | translate}}
        @if(!configurationFormService.configurationFormEmail.valid){
          <span class="icon-warning--alt text-warning ms-2"></span>
        }
      </ng-template>
      <ng-template #content>
        <app-configuration-form-email></app-configuration-form-email>
      </ng-template>
    </e-tabitem>
    <e-tabitem>
      <ng-template #headerText>
        {{'i18n.domain.export-configuration.configurations.forms.lbsftp.title' | translate}}
      </ng-template>
      <ng-template #content>
        <app-configuration-form-lbsftp></app-configuration-form-lbsftp>
      </ng-template>
    </e-tabitem>
    <e-tabitem>
      <ng-template #headerText>
        {{'i18n.domain.export-configuration.configurations.forms.ftp.title' | translate}}
        @if(!configurationFormService.configurationFormFTP.valid){
          <span class="icon-warning--alt text-warning ms-2"></span>
        }
      </ng-template>
      <ng-template #content>
        <app-configuration-form-ftp></app-configuration-form-ftp>
      </ng-template>
    </e-tabitem>
    <e-tabitem>
      <ng-template #headerText>
        {{'i18n.domain.export-configuration.configurations.forms.rest.title' | translate}}
        @if(!configurationFormService.configurationFormREST.valid){
          <span class="icon-warning--alt text-warning ms-2"></span>
        }
      </ng-template>
      <ng-template #content>
        <app-configuration-form-rest></app-configuration-form-rest>
      </ng-template>
    </e-tabitem>
    <e-tabitem>
      <ng-template #headerText>
        {{'i18n.domain.export-configuration.configurations.forms.file.title' | translate}}
        @if(!configurationFormService.configurationFormFileFields.valid
        || !configurationFormService.configurationFormFileName.valid
        || !configurationFormService.configurationFormFileLineBasedAllAttributes.valid && configurationFormService.fileProcessType === FileProcessType.LineBased
        || !configurationFormService.configurationFormFileFilter.valid){
          <span class="icon-warning--alt text-warning ms-2"></span>
        }
      </ng-template>
      <ng-template #content>
        <app-configuration-form-file></app-configuration-form-file>
      </ng-template>
    </e-tabitem>
  </e-tabitems>
</ejs-tab>
@if(id){
  <span class="id">Id: {{id}}</span>
}
